<template>
    <div class="search-footer" v-ga:impression="'msp-search-footer'">
        <section v-if="getRestAds > 0 ">
            <mvtAds :options="{type:'search', index: 4 - getRestAds}" />
        </section>
        <mvtPagination
            :pageCount='getMaxAllowedPageCount'
            :pageSize='msp.pageSize'
            :activePageNumber='msp.displayPageIndex'
            :baseUrl='baseUrl'
            :showCount='true'
            :pageDisplayLimit= "pageDisplayLimit"
            :totalCount='msp.totalCount'
            :countLabel= "pageCountLabel"
        />
        <section v-if="!glb.rentals && !getIsCommunitySearch" id="searchHotlead">
            <div class="grid fixed bg-default gap-3 inline agent-connection-lead" :class="[{'grid-cols-1': isSplitView, 'sm-grid-cols-2 xs-grid-cols-1': !isSplitView}]">
                <div class="search-adsac-container">
                    <searchAdsAgentConnection theme="lead-banner"></searchAdsAgentConnection>
                </div>
                <mvtHotleadForm :key="hotleadKey" ref="searchHotleadForm" :options="hotleadOpt" />
            </div>
        </section>
        <nav class="nav inline bg-white nogap" v-if="hasGeoInfo">
            <mvtBreadcrumb :geo="geo" :isActive="msp.filter.isActive !== 0" :contentVariant="msp.contentVariant" />
        </nav>
        <p v-if="msp.geo.neighborhoodPagePath">
            <a :href="glb.appUrl + msp.geo.neighborhoodPagePath" class="neighborhood link f7" comp="neighborhoods_msp" :data-link-name="`${glb?.geo?.neighborhood}, ${glb?.geo?.city}, ${glb?.geo?.state}`">Learn more about the {{ glb?.geo?.neighborhood ?? '' }} neighborhood</a>
        </p>
        <searchFilteredMspLinks v-if="!glb.disableLinkIndexing" />
        <section v-if="getRestAds > 1 ">
            <mvtAds :options="{type:'search', index: 4 - getRestAds + 1}" />
        </section>

        <template v-if="msp.mspGeoContent">
            <searchMarketTrends />
            <searchGeoContent />
            <template v-if="!msp.mspGeoContent.school">
                <searchSchool v-if="getSplit('movoto-msp-school-section-CW-3577') && showSearchSchool" />
                <marketschool v-else />
            </template>
        </template>
        <template v-else>
            <searchSchool v-if="getSplit('movoto-msp-school-section-CW-3577') && showSearchSchool" />
            <marketschool v-else />
            <template v-if="!glb.rentals && !(['STATE', 'COUNTY'].includes(msp.searchType))">
                <searchMarketTrends v-if="showMarketTrends"></searchMarketTrends>
                <geoLandingMarketTrends v-else :geoInfo="geo"></geoLandingMarketTrends>
            </template>
        </template>

        <section v-if="getRestAds > 2 ">
            <mvtAds :options="{type:'search', index: 4 - getRestAds + 2}" />
        </section>

        <section v-if="hasGeoInfo && !hideFaqSection && getFAQ && getFAQ.length">
            <h2 class="f4 text-bold m-b-3">Frequently Asked Questions about {{msp.contentVariant.isUnfilteredUnpaginatedCity ? 'Real Estate in ' : ''}}{{ getGeoDisplayText }}</h2>
            <mvtFaq :data="getFAQ" :attrDataNoSnippet="true"></mvtFaq>
        </section>

        <section v-if="getRestAds > 3 ">
            <div class="panel">
                <mvtAds :options="{type:'search', index: 4 - getRestAds + 3}" />
            </div>
        </section>

        <advantage v-if="hasGeoInfo" />
        <section v-if="hasSeoLinks">
            <div class="grid xs-grid-cols-1">
                <h2 class="f4 text-bold">{{molang(`search.common.nearby${glb.rentLang}`)}} {{getGeoDisplayText}}</h2>
                <searchSeoLink :rentals="glb.rentals" :cities="getNearbyCities"
                    :zipcodes="getNearbyZipcodes"
                    :neighborhoods="getNearbyNeighborhood"
                    :counties="getNearbyCounties" />
            </div>
        </section>
        <section v-if="msp.dataList && msp.dataList.length" v-for="(list,index) in msp.dataList" class="inline large">
            <mvtListLinks :title="list.title" :subTitle="list.subTitle" :links="list.data" :key="index" />
        </section>
        <section class="inline large" v-if="msp.realEstateLinks && msp.realEstateLinks.length && !glb.rentals">
            <div class="grid fixed fixed-max-sm xs-grid-cols-1 sm-grid-cols-2 md-grid-cols-3 gap-3">
                <h2 class="wrap">
                    <b class="f3 text-bold" v-if="geo.stateFullName">{{ molang('common.sitemap.mainContent.stateLinks', { state: geo.stateFullName }) }}</b>
                    <b class="f3 text-bold" v-else>Real Estate links</b>
                </h2>
                <div class="inline large corner bg-default" v-for="(item, i) in msp.realEstateLinks" :key="i">
                    <a :href="item.path" class="text-bold" :disabled="item.active">
                        {{ item.name }}
                    </a>
                </div>
            </div>
        </section>
        <section v-if="getPopularList && getPopularList.length">
            <div class="grid xs-grid-cols-1">
                <h2 class="f4 text-bold">{{molang(`search.common.popularSearches`)}}</h2>
                <ul>
                    <template v-for="(item, i) in getPopularList" :key="i">
                    <li>
                        <a class="link" :href="item.nameForUrl">
                            {{item.displayName}}
                        </a>
                    </li>
                    </template>
                </ul>
            </div>
        </section>
        <searchRelatedLinks />
        <section v-if="geo.geoType == 'GPS'">
            <div class="grid xs-grid-cols-1">
                <h2 class="f4 text-bold">{{molang('search.common.popularSearches')}}</h2>
                <div v-for="(item, i) in popularSearchesList" :key="i">
                    <a class="link" :title="item.title" :href="item.link">
                        {{molang(`search.common.${item.key}`)}}
                    </a>
                </div>
            </div>
        </section>
        <div class="msp-banner-ad" v-if="isAdsBanner">
            <mvtAds :options="{type:'banner', index:2}"></mvtAds>
        </div>
        <mvtFooter :geoInfo="hasGeoInfoInSearchUrl ? msp.geo : null"/>
    </div>
</template>

<script src="./search-footer.js"></script>

<style lang="scss">
    @use "./search-footer.scss" as *;
</style>